import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const HighSchool = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className="container mx-auto px-6 py-12">
            {/* Heading */}
            <p className="md:text-3xl text-2xl font-bold text-center mb-6">
                SVN CONVENT HIGH SCHOOL
            </p>
            <h2 className="md:text-2xl text-xl font-bold text-center mb-6">
                8th to 10th Standard
            </h2>

            {/* Description */}
            <div className="flex flex-col md:flex-row items-center justify-center md:text-left my-12" data-aos="fade-up">
                {/* Image Section */}
                <div className="md:w-1/2 flex justify-center">
                    <img 
                        src="https://img.freepik.com/free-vector/school-education-concept_52683-19635.jpg" 
                        alt="High School Learning" 
                        className="w-full md:w-4/5 h-64 rounded-lg shadow-md"
                    />
                </div>

                {/* Text Section */}
                <div className="md:w-1/2 flex items-center justify-center">
                    <p className="text-lg md:mt-0 mt-10 text-gray-700 leading-relaxed">
                        Our High School provides a strong academic foundation along with 
                        co-curricular and extracurricular activities to shape students' 
                        intellectual, social, and emotional growth. We emphasize 
                        innovation, leadership, and career preparation to help students 
                        excel in their future pursuits.
                    </p>
                </div>
            </div>

            {/* Teaching Methodology */}
            <div className="flex flex-col md:flex-row items-center my-12 md:items-start" data-aos="fade-up">
                <div className="md:w-1/2 text-left">
                    <h2 className="text-2xl font-semibold mb-4">Advanced Learning Techniques</h2>
                    <p className="text-lg text-gray-700 leading-relaxed mb-6">
                        We offer a curriculum that includes hands-on experiments, digital learning, 
                        project-based assessments, and group discussions to enhance understanding.
                    </p>
                    <h2 className="text-2xl font-semibold mb-4">Comprehensive Career Guidance</h2>
                    <p className="text-lg text-gray-700 leading-relaxed">
                        Career counseling, competitive exam preparation, and leadership training 
                        help students transition smoothly into higher education and professional fields.
                    </p>
                </div>

                {/* Right Image */}
                <div className="md:w-1/2 flex justify-center mt-6 md:mt-0">
                    <img 
                        src="https://img.freepik.com/free-vector/students-campus-concept-illustration_114360-13640.jpg" 
                        alt="Career Development" 
                        className="w-full md:w-4/5 rounded-lg shadow-md"
                    />
                </div>
            </div>

            {/* Facilities Section */}
            <h2 className="text-2xl font-bold text-center mt-12 mb-6">Facilities for High School Students</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 mb-6 gap-6" data-aos="fade-up">
                <div className="bg-white shadow-md rounded-lg p-6 text-center">
                    <img src="https://img.freepik.com/free-vector/school-classroom-cartoon-background_33099-1787.jpg" alt="Smart Classrooms" className="w-full h-40 object-cover rounded-md mb-4"/>
                    <h3 className="text-xl font-semibold">Smart Classrooms</h3>
                    <p className="text-gray-600 mt-2">Interactive boards and digital tools for an enriched learning experience.</p>
                </div>
                <div className="bg-white shadow-md rounded-lg p-6 text-center">
                    <img src="https://img.freepik.com/free-vector/sports-stadium-with-running-track_107791-3481.jpg" alt="Sports Facilities" className="w-full h-40 object-cover rounded-md mb-4"/>
                    <h3 className="text-xl font-semibold">Sports & Activities</h3>
                    <p className="text-gray-600 mt-2">Dedicated sports training, yoga, and cultural events for all-round development.</p>
                </div>
                <div className="bg-white shadow-md rounded-lg p-6 text-center">
                    <img src="https://img.freepik.com/free-vector/modern-library-bookshelves-furniture-cartoon-illustration_107791-3336.jpg" alt="Library" className="w-full h-40 object-cover rounded-md mb-4"/>
                    <h3 className="text-xl font-semibold">Library & Labs</h3>
                    <p className="text-gray-600 mt-2">Access to extensive study materials and well-equipped science labs.</p>
                </div>
            </div>

            {/* Gallery */}
            <h2 className="text-2xl font-bold text-center mt-12 mb-6">Gallery</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-8" data-aos="fade-up">
                <img src="https://img.freepik.com/free-vector/science-lab-students-experiment_1308-88000.jpg" alt="Science Lab" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/classroom-students-cartoon-style_1308-88056.jpg" alt="Classroom Learning" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/book-reading-group-kids-library_1308-89704.jpg" alt="Library Reading" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/sports-day-school-kids_1308-90265.jpg" alt="Sports Activities" className="w-full h-48 object-cover rounded-lg shadow-md" />
            </div>
        </div>
    );
}

export default HighSchool;
